import React from 'react';

/**
 * Corta o texto em `limite` caracteres, terminando em "…". Para casos em que
 * CSS não resolve (ex.: <option> de um <select> nativo, que ignora
 * text-overflow e faz a lista abrir com a largura do maior nome).
 */
export const truncarTexto = (texto: string | null | undefined, limite: number = 50): string => {
  const valor = texto ?? '';
  return valor.length > limite ? `${valor.slice(0, limite - 1).trimEnd()}…` : valor;
};

interface TextoTruncadoProps {
  texto?: string | null;
  // Largura máxima antes de cortar com "…" (px ou qualquer valor CSS).
  maxWidth?: number | string;
  className?: string;
  // Exibido quando não há texto.
  fallback?: string;
}

/**
 * Texto em uma linha só: corta com "…" ao passar de `maxWidth` e mostra o
 * conteúdo completo no tooltip ao passar o mouse (mesmo padrão já usado na
 * listagem de empenhos: text-truncate + maxWidth + title).
 */
const TextoTruncado: React.FC<TextoTruncadoProps> = ({
  texto,
  maxWidth = 240,
  className = '',
  fallback = '-',
}) => {
  const valor = texto ?? '';
  return (
    <span
      className={`text-truncate d-inline-block align-bottom ${className}`.trim()}
      style={{ maxWidth }}
      title={valor}
    >
      {valor || fallback}
    </span>
  );
};

export default TextoTruncado;
